import { jstDaysUntil } from '../utils/jstDate'

export const CARD_STYLES = {
  school: { chip: '#da4574', pill: '#fff0f4', accent: '#da4574' },
  entre:  { chip: '#ebad47', pill: '#fdf8f0', accent: '#ebad47' },
  system: { chip: '#65c1c8', pill: '#e9f9fa', accent: '#65c1c8' },
} as const

export function formatDeadlineDate(deadline: string): string {
  const d = new Date(deadline)
  const days = ['日', '月', '火', '水', '木', '金', '土']
  return `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日（${days[d.getDay()]}）`
}

const CalendarIcon = () => (
  <svg className="w-3.5 h-3.5 fill-current shrink-0" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M152 24c0-13.3-10.7-24-24-24S104 10.7 104 24V64H48C21.5 64 0 85.5 0 112v16 16V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V144 128 112c0-26.5-21.5-48-48-48H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V464H48V192z" />
  </svg>
)

export interface HomeworkCardProps {
  cardType: keyof typeof CARD_STYLES
  chipLabel: string
  title: string
  deadlineAt: string | null
  isPlaceholder?: boolean
  onClick?: () => void
}

const HomeworkCard = ({ cardType, chipLabel, title, deadlineAt, isPlaceholder, onClick }: HomeworkCardProps) => {
  const s = CARD_STYLES[cardType]
  // 締切はその日の終わり（JST）なので、締切当日はまだ提出できる
  const daysLeft = deadlineAt ? jstDaysUntil(deadlineAt) : null
  const countdownText = daysLeft === null ? null
    : daysLeft < 0 ? '期限切れ'
    : daysLeft === 0 ? '今日まで'
    : `あと${daysLeft}日`

  const inner = (
    <div className={`bg-white rounded-lg shadow-[0_0_4px_rgba(0,0,0,0.16)] flex flex-col items-center gap-2 px-6 py-4 w-full h-full${isPlaceholder ? ' opacity-60' : ''}`}>
      <span className="text-white text-sm font-bold px-5 py-1 rounded-full whitespace-nowrap" style={{ backgroundColor: s.chip }}>
        {chipLabel}
      </span>
      <div className="text-center text-lg font-bold text-[#33333b] leading-snug overflow-hidden w-full" style={{ maxHeight: '3.5rem' }}>
        {title}
      </div>
      <div className="flex items-center justify-center flex-wrap gap-x-3 gap-y-1 w-full px-4 py-2 rounded-full" style={{ backgroundColor: s.pill }}>
        <div className="flex items-center gap-1 text-[#72727c]">
          <span className="text-sm">締切</span>
          <CalendarIcon />
          <span className="text-sm">{deadlineAt ? formatDeadlineDate(deadlineAt) : 'なし'}</span>
        </div>
        {countdownText && (
          <span className="text-sm font-bold" style={{ color: s.accent }}>{countdownText}</span>
        )}
      </div>
    </div>
  )

  // Fixed width matching one of three cards in the row (gap-3 = 0.75rem, 2 gaps),
  // so cards keep this width instead of stretching when some are hidden.
  const sizing = 'min-w-[220px] grow-0 shrink-0 basis-[calc((100%-1.5rem)/3)]'

  if (!isPlaceholder && onClick) {
    return (
      <button onClick={onClick} className={`${sizing} text-left focus:outline-none`}>
        {inner}
      </button>
    )
  }
  return <div className={sizing}>{inner}</div>
}

export default HomeworkCard
